import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface UpdateInvestmentTransactionPayload {
  investmentUuid: string;
  transactionUuid: string;
  type?: "buy" | "sell";
  quantity?: number | null;
  unitPrice?: number | null;
  totalValue?: number | null;
  currencyUuid?: string;
  note?: string | null;
  completedAt?: string | null;
  fileId?: number | null;
}

export const useUpdateInvestmentTransaction = (
  options?: UseMutationOptions<any, Error, UpdateInvestmentTransactionPayload>,
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateInvestmentTransaction"],
    mutationFn: async ({
      investmentUuid,
      transactionUuid,
      ...data
    }: UpdateInvestmentTransactionPayload) => {
      return axiosInstance
        .patch(
          `/investments/${investmentUuid}/transactions/${transactionUuid}`,
          data,
        )
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa aktualizacja transakcji...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "update-investment-transaction",
      });
      if (options?.onMutate) {
        return options.onMutate(variables) as any;
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Transakcja zaktualizowana pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "update-investment-transaction",
      });
      queryClient.invalidateQueries({
        queryKey: ["investmentTransactions", variables.investmentUuid],
      });
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas aktualizacji transakcji.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "update-investment-transaction",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
